import { FC } from "react";

import { Stack, Box } from "@chakra-ui/react";

import OptionButtonGroupRow from "./OptionButtonRow";
import { TOptionButtonGroupRowListProps, TOptionButtonValue } from "./types";
import mapToMultipleRows from "./utils/mapToMultipleRows";

const getKey = (index: number, value: TOptionButtonValue) => `multiline-option-row-${value}-${index}`;

const OptionButtonGroupRowList: FC<TOptionButtonGroupRowListProps> = ({
  options,
  value,
  onChange,
  lines,
  name,
  testId,
  isMultiple,
}) => (
  <Stack direction="column" spacing="0.625rem">
    {mapToMultipleRows({ options, lines }).map((row, index) => (
      <Box key={getKey(index, row[0].value)}>
        <OptionButtonGroupRow
          options={row}
          onChange={onChange}
          value={value}
          isFullWidth
          name={name}
          testId={testId}
          noWrap
          isMultiple={isMultiple}
        />
      </Box>
    ))}
  </Stack>
);

export default OptionButtonGroupRowList;
